"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDropdownItemsFilteredBody = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var react_intl_1 = require("react-intl");
exports.AttributeDropdownItemsFilteredBody = function (_a) {
    var parentFilterTitles = _a.parentFilterTitles, showItemsFilteredMessage = _a.showItemsFilteredMessage;
    if (!parentFilterTitles || !showItemsFilteredMessage) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "gd-attribute-filter-dropdown-items-filtered s-attribute-filter-dropdown-items-filtered" },
        react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0 },
            react_1.default.createElement("div", { className: "gd-filtered-message" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "attributesDropdown.itemsFiltered" }),
                react_1.default.createElement("span", { className: "gd-icon-circle-question" })),
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary gd-attribute-filter-dropdown-bubble s-attribute-filter-dropdown-bubble", alignPoints: [{ align: "bc tl" }, { align: "tc bl" }], arrowOffsets: { "bc tl": [-100, 10], "tc bl": [-100, -10] } },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "attributesDropdown.itemsFiltered.tooltip", values: {
                        filters: parentFilterTitles.join(", "),
                        strong: function (chunks) { return react_1.default.createElement("strong", null, chunks); },
                    } })))));
};
//# sourceMappingURL=AttributeDropdownItemsFilteredBody.js.map